'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Application = require('pricing-pages-unified-ui/containers/Application');

var _Application2 = _interopRequireDefault(_Application);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _FreeToolsPage = require('./components/free-tools-page/FreeToolsPage');

var _FreeToolsPage2 = _interopRequireDefault(_FreeToolsPage);

var _BundlePage = require('./components/bundle-page/BundlePage');

var _BundlePage2 = _interopRequireDefault(_BundlePage);

var _ContactsConfirmationPage = require('./components/contacts-confirmation-page/ContactsConfirmationPage');

var _ContactsConfirmationPage2 = _interopRequireDefault(_ContactsConfirmationPage);

var _SalesHubPage = require('./components/SalesHubPage');

var _SalesHubPage2 = _interopRequireDefault(_SalesHubPage);

var _MarketingHubPage = require('./components/MarketingHubPage');

var _MarketingHubPage2 = _interopRequireDefault(_MarketingHubPage);

var _ServiceHubPage = require('./components/ServiceHubPage');

var _ServiceHubPage2 = _interopRequireDefault(_ServiceHubPage);

var _CmsPage = require('./components/cms-page/CmsPage');

var _CmsPage2 = _interopRequireDefault(_CmsPage);

var _GrowthSuitePage = require('./components/growth-suite-page/GrowthSuitePage');

var _GrowthSuitePage2 = _interopRequireDefault(_GrowthSuitePage);

var _ErrorPage = require('./components/ErrorPage');

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _SuiteContactsConfirmationPage = require('./components/contacts-confirmation-page/SuiteContactsConfirmationPage');

var _SuiteContactsConfirmationPage2 = _interopRequireDefault(_SuiteContactsConfirmationPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Routes(_ref) {
  var defaultRoute = _ref.defaultRoute;

  return _react2.default.createElement(
    _Application2.default,
    null,
    _react2.default.createElement(
      _reactRouterDom.Switch,
      null,
      _react2.default.createElement(_reactRouterDom.Route, { path: '/crm', component: _FreeToolsPage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/bundle', component: _BundlePage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/confirm-contacts', component: _ContactsConfirmationPage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, {
        path: '/confirm-suite-contacts',
        render: _SuiteContactsConfirmationPage2.default
      }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/sales', component: _SalesHubPage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/service', component: _ServiceHubPage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms', component: _CmsPage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/growth-suite', component: _GrowthSuitePage2.default }),
      _react2.default.createElement(_reactRouterDom.Route, { path: '/marketing', component: _MarketingHubPage2.default }),
      _react2.default.createElement(_reactRouterDom.Redirect, { from: '/', exact: true, to: defaultRoute }),
      _react2.default.createElement(_reactRouterDom.Route, { component: _ErrorPage2.default })
    )
  );
}
exports.default = Routes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/Routes.js
// module id = 640
// module chunks = 3 4